(function ($) {
  $(document).ready(function() {
    $(".jzd-js-phone-number").focus(function(){
      show_guide();
    }).blur(function() {
      hide_guide();
    });

    $(".jzd-js-phone-number").on('input',function(){
      show_guide();
    });

    function show_guide() {
      var value = $(".jzd-js-phone-number").val();
      var left = $(".jzd-js-phone-number").offset().left + 3.141;
      var top = $(".jzd-js-phone-number").offset().top - $("body").offset().top - 39;
      $("#FFbi1546").css("left", left)
      $("#FFbe1546").css("left", left)
      $("#FFbi1546").css("top", top)
      $("#FFbe1546").css("top", top)
      if (value.length == 0){
        $("#FFbi1546").show();
        $("#FFbe1546").hide();
      } else if (value.length < 11) {
        $("#FFbi1546").hide();
        $("#FFbe1546").show();
      } else {
        hide_guide();
      }
    }

    function hide_guide() {
      $("#FFbi1546").hide();
      $("#FFbe1546").hide();
    }
  });
})(jQuery);
